<template>
  <div id="footer">
    <div class="inner">
      <div class="footer_area">
        <ul>
          <li>
            <a href="http://www.1242.com/" target="_blank">
              AM1242 FM93 ニッポン放送
            </a>
          </li>
          <li>
            <a href="http://www.allnightnippon.com/" target="_blank">
              オールナイトニッポン
            </a>
          </li>
        </ul>
      </div>
      <div class="logo_footer">
          <img src="images/logo_footer.png" width="330" height="40" alt=""/>
      </div>
      <p class="copy">
        Copyright © Nippon Broadcasting System,Inc. All Rights Reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
